import { MAX_2B_ASN, formatAsn } from '@ipfabric/utils';

import { isFeatureFlagEnabled } from '@ipfabric/ui-components/utils/featureFlags';

const asnToNumber = (asn: number | string | null): number | null => {
  if (asn === null) {
    return null;
  }

  const parts =
    typeof asn === 'string' ? asn.split('.') : asn.toString().split('.');

  if (parts.length === 1) {
    // properly parse asplain
    return Number.parseInt(parts[0]!, 10);
  }

  const integerAsn = parts.reduce((acc: number | null, part) => {
    const intPart = Number.parseInt(part, 10);

    if (
      Number.isNaN(intPart) ||
      intPart < 0 ||
      intPart >= MAX_2B_ASN ||
      acc === null
    ) {
      return null;
    }

    return acc * MAX_2B_ASN + intPart;
  }, 0);

  return integerAsn;
};

const asnToString = (value: number): string => {
  return (
    formatAsn(
      value,
      isFeatureFlagEnabled('ENABLE_BGP_ASPLAIN_FORMAT') ? 'asplain' : 'asdot',
    ) ?? ''
  );
};

export const asnValueConvertor = {
  toNumber: asnToNumber,
  toString: asnToString,
};
